import React from 'react'
import Navbar from './Navbar'
import "../Components/ContactUs.css"
function ContactUs() {
  return (
    <>
    <div>
        <Navbar />
      
<div className='Contact_body'>
    <br/>
    <div class="col">
          <br/>
          <div class="col-md-15 mb-3">
            <div class="card">
              <div class="card-body text-right mt-auto">
                <h5 class="card-title d-flex justify-content-between">
                    <div class="float-left">Shiwaditya</div>
                    <div class="float-center text-center">+91-9067582475</div>
                    <div class="float-right">CSE</div>
                </h5>
              </div>
              <br/>
            </div>
          </div>

          <br/>

          <div class="col-md-15 mb-3">
            <div class="card">
              <div class="card-body text-right mt-auto">
                <h5 class="card-title d-flex justify-content-between">
                    <div class="float-left">Siddhi</div>
                    <div class="float-center text-center">+91-8624008351</div>
                    <div class="float-right">CSE</div>
                </h5>
              </div>
              <br/>
            </div>
          </div>

          <br/>


          <div class="col-md-15 mb-3">
            <div class="card">
              <div class="card-body text-right mt-auto">
                <h5 class="card-title d-flex justify-content-between">
                    <div class="float-left">Rushikesh</div>
                    <div class="float-center text-center">+91-9119458861</div>
                    <div class="float-right">CSE</div>
                </h5>
              </div>
              <br/>
            </div>
          </div>

          <br/>

    </div>
    
</div>


    </div>
    </>
  )
}

export default ContactUs
